import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Page.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    program: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    alert('Thank you for your interest! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      program: '',
      message: ''
    });
  };

  return (
    <div className="page">
      <section className="page-hero page-hero--red">
        <div className="container">
          <h1>Get in Touch</h1>
          <p className="hero-subtitle">Have questions about our programs, teaching methodology, or need general information? We'd love to hear from you. For program applications, please use the <a href="/apply" style={{ color: 'rgba(255,255,255,0.9)', textDecoration: 'underline' }}>Apply Now</a> page.</p>
        </div>
      </section>

      <section className="page-content section">
        <div className="container">
          <div className="contact-wrapper">
            <div className="contact-info">
              <h2>Contact Information</h2>
              <div className="info-item">
                <h3>Email</h3>
                <p>qbetagroup@gmail.com</p>
              </div>
              <div className="info-item">
                <h3>Phone / WhatsApp</h3>
                <p>+91 72057 06992</p>
              </div>
              <div className="info-item">
                <h3>Mode</h3>
                <p>Online Learning Platform</p>
              </div>
              <div className="info-item">
                <h3>Location</h3>
                <p>Bhubaneswar, Odisha (Upcoming Offline Center)</p>
              </div>
              <div className="info-item">
                <Link to="/academy/apply" className="btn btn-primary btn-large" style={{ marginTop: '1rem', display: 'inline-block' }}>
                  Talk to Our Team
                </Link>
              </div>
            </div>

            <div className="contact-form-wrapper">
              <h2>Send Us a Message</h2>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="program">Program of Interest</label>
                  <select
                    id="program"
                    name="program"
                    value={formData.program}
                    onChange={handleChange}
                  >
                    <option value="">Select a program</option>
                    <option value="data-analytics">Data Analytics</option>
                    <option value="data-engineering">Data Engineering</option>
                    <option value="data-science-ai">Data Science & AI</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary btn-large">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;

